import React, { useEffect } from "react";
import HomeBanner from "./HomeBanner/HomeBanner";
import ShopBySeller from "./ShopBySeller/ShopBySeller";
import PopularCategories from "./PopularCategories/PopularCategories";
import OurProduct from "./OurProduct/OurProduct";
import SelectByCategories from "./SelectByCategories/SelectByCategories";
import Marquee_Holder from "./Marquee_Holder/Marquee_Holder";
import NewArrival from "./NewArrival/NewArrival";
import RecentViewedProducts from "./RecentViewedProducts/RecentViewedProducts";
import Coupons from "./Coupons/Coupons";
import Sale_product from "./Sale_product/Sale_product";

const HomePage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // });

  return (
    <>
      <HomeBanner />

      {/* <ShopBySeller /> */}
      <Marquee_Holder />
      <NewArrival />
      <SelectByCategories />
      {/* <PopularCategories /> */}
      <OurProduct />

      {/* <Sale_product/> */}
      <RecentViewedProducts />

      <Coupons sectionId="couponSection" />
    </>
  );
};

export default HomePage;
